import { Tabs } from "antd";
import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";
import { WalletAddressType } from "@lib/types/Billing";
import { ConfigComponentProps } from "../ConfigComponent";
import ScanConfigTabComponent from "./Tabs";

export default function ScanConfig(props: ConfigComponentProps) {
  const scanConfigTabKeys = Object.keys(
    props.config?.data,
  ) as WalletAddressType[];

  const items = scanConfigTabKeys.map((key) => ({
    key: key,
    label: key,
    icon: <img src={walletAddressTypeImage(key)} style={{ height: "20px" }} />,
    children: <ScanConfigTabComponent {...(props as any)} tab={key} />,
  }));

  return (
    <>
      <Tabs defaultActiveKey={items[0].key} items={items} tabPosition="left" />
    </>
  );
}
